export const payprizeConstants = {
  HOME_PAYPRIZE_REQUEST: 'HOME_PAYPRIZE_REQUEST',
  HOME_PAYPRIZE_SUCCESS: 'HOME_PAYPRIZE_SUCCESS',
  HOME_PAYPRIZE_FAILURE: 'HOME_PAYPRIZE_FAILURE',

  SINGLE_PAYPRIZE_REQUEST: 'SINGLE_PAYPRIZE_REQUEST',
  SINGLE_PAYPRIZE_SUCCESS: 'SINGLE_PAYPRIZE_SUCCESS',
  SINGLE_PAYPRIZE_FAILURE: 'SINGLE_PAYPRIZE_FAILURE'
};
